import { Box, Button, Flex, Image, Typography } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import ReactTooltip from "react-tooltip"
import styled from "styled-components"

export const Paragraph = styled(Typography).attrs((props) => ({
  color: "neutral",
  mb: 2,
  ...props,
}))`
  a {
    color: ${(props) => props.theme.order.link.color};
    text-decoration: ${(props) => props.theme.order.link.textDecoration};
  }
`

export const SectionTitle = styled(Typography).attrs((props) => ({
  as: "h2",
  fontSize: "26px",
  fontWeight: "500",
  lineHeight: "30px",
  mb: 1,
  ...props,
}))``

export const Tooltip = styled(ReactTooltip).attrs((props) => ({
  effect: "solid",
  place: "right",
  ...props,
}))`
  letter-spacing: 0.03em;
  max-width: 210px;
`
export const MsgWrap = styled(Box).attrs((props) => ({
  borderRadius: "10px",
  borderStyle: "solid",
  borderWidth: "1px",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "22px",
  mb: 2,
  p: 3,
  ...props,
}))``

export const Text = styled(Typography).attrs((props) => ({
  fontSize: "16px",
  fontWeight: "300",
  letterSpacing: "-0.02em",
  lineHeight: "22px",
  ...props.theme.order.formText,
  ...props,
}))`
  a {
    font-weight: 500;
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }

  strong {
    font-weight: 500;
  }
`

export const StyledLink = styled(Typography).attrs((props) => ({
  as: Link,
  color: "primary",
  ...props,
}))`
  text-decoration: underline;
`
export const ButtonLink = styled(Typography).attrs((props) => ({
  as: Link,
  ...props,
}))`
  background: ${(props) =>
    props.outline ? props.theme.colors.white : props.theme.colors.primary};
  border: ${(props) =>
    props.outline && `1px solid ${props.theme.colors.primary}`};
  color: ${(props) =>
    props.outline ? props.theme.colors.primary : props.theme.colors.white};
  display: block;
  font-size: 18px;
  font-weight: 500;
  line-height: 16px;
  padding: 14px 24px;
  text-align: center;
  width: 100%;
  &:hover {
    color: ${(props) =>
      props.outline ? props.theme.colors.primary : props.theme.colors.white};
  }
`

export const SubmitButton = styled(Button).attrs((props) => ({
  type: "submit",
  variant: "primary",
  width: "100%",
  ...props,
}))`
  font-size: 18px;
  font-weight: 500;
  line-height: 16px;
  padding: 14px 24px;
`

export const FormContainer = styled(Box).attrs({
  mb: { _: 8, tablet: "100px" },
  mt: 6,
})``

export const FormWrapper = styled(Box).attrs({
  maxWidth: { tablet: "560px" },
})``

export const TitleContainer = styled(Flex)`
  align-items: center;
  margin-bottom: 32px;
`

export const FormTitle = styled(Typography).attrs((props) => ({
  as: "h1",
  fontSize: "32px",
  fontWeight: "700",
  lineHeight: "36px",
  m: 0,
  ...props,
}))``

export const InputWrapper = styled(Box).attrs((props) => ({
  mb: 2,
  width: { _: "100%", tablet: "320px" },
  ...props,
}))``

export const OrderNumber = styled(Typography)`
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  margin-bottom: 16px;
`

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 6px;
`

export const ImgWrapper = styled(Box).attrs((props) => ({
  border: `1px solid ${props.theme.colors.grey[20]}`,
  mb: { _: 2, tablet: 0 },
  mr: { tablet: 2 },
  width: { _: "100%", tablet: "265px" },
  ...props.theme.order.imageWrapper,
  ...props,
}))``

export const ProductContainer = styled(Flex).attrs({
  alignItems: { tablet: "center" },
  flexDirection: { _: "column", tablet: "row" },
  mb: 2,
})``

export const ProductImg = styled(Image).attrs({
  lazyload: false,
  maxHeight: "100%",
  maxWidth: "100%",
})`
  aspect-ratio: 1;
`

export const ProductTitle = styled(Typography).attrs((props) => ({
  as: "h3",
  fontSize: "20px",
  fontWeight: "500",
  lineHeight: "20px",
  ...props,
}))``

export const CancelButton = styled(Button).attrs((props) => ({
  forwardedAs: Link,
  variant: "text",
  ...props,
}))`
  color: ${(props) => props.theme.colors.primary};
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  padding: 14px 24px;
  text-decoration: underline;
  width: 100%;
  &:focus,
  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
  &:hover {
    text-decoration: none;
  }
`

export const FeesWrap = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.grey[20]};
  margin-bottom: 32px;
  padding: 32px;
  ${(props) => props.theme.mediaQueries.tablet`
    display: inline-block;
    padding: 32px 48px;
  `}
`
